export default __webpack_public_path__ + "dd067fc7419462a803daaf87eec9fac6.png";